import { graficoValorQuantidadeMultiploStyles } from './GraficoValorQuantidadeMultiplo.style'

export function graficoValorQuantidadeMultiploIO() {
  return {
    styles: graficoValorQuantidadeMultiploStyles
  }
}

export type GraficoValorQuantidadeMultiploIO = ReturnType<typeof graficoValorQuantidadeMultiploIO>
